/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-01 17:08:32
 * @LastEditTime: 2019-08-15 20:54:30
 * @LastEditors: Please set LastEditors
 */

var base
if(process.env.NODE_ENV=='development'){
    base={
      
        client_id:10088005,
        // client_secret:'k9Tofsg62NzEhRfnFgC98SUVGqXbZE5L4RfnEEnq'
        client_secret:'Hn6CZmKZtc8PRL3DE9N5pHamV15i9cMI8Qh4khnh'
       
    }
}else{
    base={
        client_id:10088005,
        client_secret:'Hn6CZmKZtc8PRL3DE9N5pHamV15i9cMI8Qh4khnh'
       
    }
}


export default base
